<template>
  <div>
    <b-navbar
      id="project-topbar"
      class="pt-4"
    >
      <!--<b-col sm="4" align="left">-->
      <!--</b-col>-->
      <b-col
        sm="4"
        align="center"
      />
      <b-col
        sm="4"
        align="right"
      />
    </b-navbar>

    <div
      id="project-container"
      class="row"
    >
      <div
        id="section-nav-container"
        ref="sectionNavContainer"
        class="col-md-2 d-print-none"
      >
        <Affix
          relative-element-selector="#router-container-outer-col"
          :style="affixStyle"
        >
          <b-list-group vertical>
            <project-section-nav
              v-for="(section, index) in sectionNavLinks"
              :id="section.id"
              :key="index + 1"
              :number="index + 1"
              :text="section.title"
              :to="section.to"
            />

            <b-button
              to="./5"
              class="mt-3"
              :variant="valid['5'] ? 'success': 'dark'"
              :disabled="!valid['5']"
              @click="saveProject"
            >
              <b-row>
                <b-col>Report</b-col>
              </b-row>
            </b-button>
          </b-list-group>

          <div
            id="project-details-sidebar"
            class="mt-3"
          >
            <h1 id="main-project-name">
              {{ project.projectName }}
            </h1>
            <h3 class="sidebar-text">
              {{ project.city }}, {{ project.state }}
            </h3>
            <h2
              v-if="project.projectId !== null && project.projectId !== ''"
              class="sidebar-text"
            >
              Project ID: {{ project.projectId }}
            </h2>
            <h3
              v-if="project !== null && project.lastModified !== null"
              id="save-confidence"
              class="sidebar-text"
              style="font-style: italic"
            >
              Last Saved <br> {{ lastSavedDate }} at {{ lastSavedTime }}
              <!--{{currentPageValidationState}}-->
            </h3>
          </div>

          <b-button
            variant="primary"
            :disabled="saveButtonIsDisabled"
            @click="manualSave"
          >
            Save
          </b-button>
        </Affix>
      </div>

      <b-modal
        ref="check-validation-modal"
        :ok-only="true"
        title="Warning"
      >
        <b-alert
          show
          variant="danger"
        >
          Please check that all inputs are valid before saving or navigating to another page.
        </b-alert>
      </b-modal>

      <div
        id="router-container-outer-col"
        class="col-md-10"
      >
        <!--<b-container class="h-100" id="router-container">-->
        <router-view align="left" />
        <!--</b-container>-->
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import { mapActions } from 'vuex';
  // const { mapActions } = createNamespacedHelpers('rx');

  import dayjs from 'dayjs';
  import { Affix } from 'vue-affix';

  import ProjectSectionNav from "./ProjectSectionNav";

  export default {
    name: "ProjectCreationContainer",
    components: {
      ProjectSectionNav,
      Affix
    },
    computed: {
      ...mapState ({
        project: state => state.rx.currentProject,
        valid: state => state.rx.currentProjectIsValid.section,
        currentPageValidationState: state => state.rx.currentPageValidationState
      }),
      lastSavedDate(){
        return dayjs(this.project.lastModified.date)
          .subtract(new Date().getTimezoneOffset(), 'minute')
          .format('MMMM D, YYYY');
      },
      lastSavedTime(){
        return dayjs(this.project.lastModified.date)
          .subtract(new Date().getTimezoneOffset(), 'minute')
          .format('hh:mm A');
      },
      isReadyForSave(){
        return this.checkIfReadyForSave()
      },
      saveButtonIsDisabled(){
        if (this.currentPageValidationState !== null){
          return !this.currentPageValidationState.$anyDirty
        }
        return true
      }


    },
    data: function() {
      return {
        sectionNavLinks: [
          { title: "Project Information", to: "./1", id: "1", valid: false },
          { title: "Existing Section", to: "./2", id: "2", valid: false  },
          { title: "Distress Survey", to: "./3", id: "3", valid: false  },
          { title: "Additional Factors", to: "./4", id: "4", valid: false  },
          // { title: "Select Renewal", to: "./5", id: "5", valid: false  }
        ],
        affixStyle: {
          // vue-affix requires absolute width to be set. This is done in mounted()
        }
      };
    },
    methods: {
      ...mapActions('rx',[
        'validateProjectState',
        'saveProject',
        'getFullProject'
      ]),
      dateDisplay(phpDate){
        // Convert ISO UTC datetime to local timezone and generate display text
        console.log(phpDate);
        const isoDate = phpDate.date;
        return dayjs(isoDate)
          .subtract(new Date().getTimezoneOffset(), 'minute')
          .format('MMMM D, YYYY hh:mm A');
      },

      checkIfReadyForSave(){
        // Allows loading of invalid values from database and free navigation/saving until touched by user
        // Allow save if:
        //  - All boxes with dirty input are valid
        //  - All boxes with invalid input are not dirty

        const v = this.currentPageValidationState;
        const hasNoBlockingErrors = Object.keys(v.$params).every(p => v[p].$error === false);
        Object.keys(v.$params).map(p => {if(v[p].$error){ console.log(p)}});
        return hasNoBlockingErrors
      },
      manualSave(){
        if (!this.checkIfReadyForSave()){
          this.$refs['check-validation-modal'].show()
        } else {
          this.saveProject()
        }
      }
    },
    created(){
      console.log(this.$route.params);
      const projectId = Number(this.$route.params.projectId);
      this.getFullProject(projectId);
    },
    beforeMount() {
      // When project page is loaded perform validation
      this.validateProjectState()
    },
    mounted(){
      const sidebarWidth = this.$refs.sectionNavContainer.clientWidth;
      console.log("Width of sidebar is", sidebarWidth);
      this.affixStyle.width = sidebarWidth.toString() + 'px'
    },
    beforeDestroy(){
      this.saveProject()
    },
    beforeRouteUpdate(from, to, next){
      if (!this.isReadyForSave){
        this.$refs['check-validation-modal'].show()
      } else {
        this.saveProject();
        next()
      }
    }
  };
</script>

<style scoped>
  #project-container {
    width: 100%;
    /*height: 600px;*/
    /*border-style: solid;*/
    /*border-color: red;*/
    padding-left: 0;
    padding-right: 0;
    margin-left: 0;
    margin-right: 0;
  }

  #main-project-name{
    font-size:160%;
  }

  .sidebar-text{
    font-size:100%;
  }

  #section-nav-container {
    padding: 0;
  }

  @media print{
    #router-container-outer-col {
      display: block
    }
  }

  #project-details-sidebar {
    color: black;
  }
</style>

<style>
  .card-header h4 {
    margin: 0;
    text-align: left;
  }

  /*.form-text {*/
  /*  text-align: left;*/
  /*}*/

  @media print {
    #section-nav-container {
      visibility: hidden;
    }

    .col-md-10 {
      width: 100%;
      max-width: 100%;
      flex: 0 0 100%;
    }

    body{
      font: 10pt Avenir, Helvetica, Arial, sans-serif;
      line-height: 1.1;
    }
  }

</style>
